import { computed } from "vue";
import {
  hasOrdersReadPermission,
  hasOrdersWritePermission,
  isExclusivelyParticipant,
} from "@/composables/authorization.js";
import {
  VIZ_CAREER_AND_SKILLS_URL,
  VIZ_CURRICULUM_INTEGRATION_URL,
  VIZ_FORMS_URL,
  VIZ_FORMS_URL_TEST,
  VIZ_HOME_URL,
  VIZ_INTERESTED_STUDENTS_REPORT,
  VIZ_MY_STUDENTS_URL,
  VIZ_ORDERS_ACTUAL_HOUSING_BOOKINGS_REPORT,
  VIZ_ORDERS_EXCURSIONS_INTERNATIONAL_REPORT,
  VIZ_ORDERS_HOUSING_INTERNATIONAL_REPORT,
  VIZ_ORDERS_MISCELLANEOUS_PRODUCTS_REPORT,
  VIZ_ORDERS_REPORT,
  VIZ_RESEARCH_URL,
} from "@/constants.js";
import store from "@/store/index.js";

export const entityId = computed(() => {
  return store.getters.getEntityIds?.[0];
});

export const researchVizSource = computed(() => (!isExclusivelyParticipant.value ? VIZ_RESEARCH_URL : ""));

export const curriculumIntegrationVizSource = computed(() =>
  !isExclusivelyParticipant.value ? VIZ_CURRICULUM_INTEGRATION_URL : "",
);

export const homeVizSource = computed(() => (!isExclusivelyParticipant.value ? VIZ_HOME_URL : ""));

export const myStudentsVizSource = computed(() => (!isExclusivelyParticipant.value ? VIZ_MY_STUDENTS_URL : ""));

export const careerAndSkillsVizSource = computed(() =>
  !isExclusivelyParticipant.value ? VIZ_CAREER_AND_SKILLS_URL : "",
);

export const formsVizSource = computed(() => {
  const onboardingTodosReportV2Flag = store.state.featureFlags["onboarding-todos-report-v2"];
  const vizFormsUrl = onboardingTodosReportV2Flag ? VIZ_FORMS_URL_TEST : VIZ_FORMS_URL;
  return !isExclusivelyParticipant.value ? vizFormsUrl : "";
});

export const ordersReportSource = computed(() => (hasOrdersReadPermission.value ? VIZ_ORDERS_REPORT : ""));

export const ordersMiscellaneousProductsReportSource = computed(() =>
  hasOrdersWritePermission.value ? VIZ_ORDERS_MISCELLANEOUS_PRODUCTS_REPORT : "",
);

export const ordersActualHousingBookingsReportSource = computed(() =>
  hasOrdersWritePermission.value ? VIZ_ORDERS_ACTUAL_HOUSING_BOOKINGS_REPORT : "",
);

export const ordersHousingInternationalReportSource = computed(() =>
  hasOrdersWritePermission.value ? VIZ_ORDERS_HOUSING_INTERNATIONAL_REPORT : "",
);

export const ordersExcursionsInternationalReportSource = computed(() =>
  hasOrdersWritePermission.value ? VIZ_ORDERS_EXCURSIONS_INTERNATIONAL_REPORT : "",
);

export const interestedStudentsReportSource = VIZ_INTERESTED_STUDENTS_REPORT;
